import * as React from 'react';
import { withRouter } from "react-router-dom";
import UserForm from '../components/UserForm';

const OrganizationUserDetail = (props: any) => {
    return (
        <UserForm />
    )
}

export default withRouter(OrganizationUserDetail)


// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationUserDetail.tsx